document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".nova-video-wrapper").forEach(wrapper=>{

        const poster=wrapper.querySelector(".nova-video-poster");

        const button=wrapper.querySelector(".nova-video-play");

        const video=wrapper.querySelector("video");

        if(!video || !poster) return;

        button.addEventListener("click",()=>{

            wrapper.classList.add("is-playing");

            video.play();

        });

        video.addEventListener("ended",()=>{

            wrapper.classList.remove("is-playing");

            video.currentTime=0;

        });

    });

});